import * as tslib_1 from "tslib";
var UrlUtils = /** @class */ (function () {
    function UrlUtils() {
    }
    UrlUtils.getUrlParams = function (customUrl) {
        var url = customUrl || window.location.href;
        url = decodeURIComponent(url);
        var questionMarkPosition = url.indexOf('?');
        if (questionMarkPosition < 0) {
            return {};
        }
        url = url.substr(questionMarkPosition + 1);
        return UrlUtils.parseQueryString(url);
    };
    UrlUtils.serializeUrlParams = function (params) {
        var e_1, _a;
        if (Object.keys(params).length === 0) {
            return '';
        }
        var paramString = '?';
        try {
            for (var _b = tslib_1.__values(Object.keys(params)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                paramString += key + "=" + params[key] + "&";
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return paramString.slice(0, -1);
    };
    UrlUtils.parseQueryString = function (queryString) {
        var data = {};
        if (queryString === null) {
            return data;
        }
        var pairs = queryString.split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i];
            var separatorIndex = pair.indexOf('=');
            var escapedKey = void 0, escapedValue = void 0;
            if (separatorIndex === -1) {
                escapedKey = pair;
                escapedValue = null;
            }
            else {
                escapedKey = pair.substr(0, separatorIndex);
                escapedValue = pair.substr(separatorIndex + 1);
            }
            var key = decodeURIComponent(escapedKey);
            var value = decodeURIComponent(escapedValue);
            if (key.substr(0, 1) === '/') {
                key = key.substr(1);
            }
            data[key] = value;
        }
        return data;
    };
    return UrlUtils;
}());
export { UrlUtils };
